export enum ModalType {
  Add,
  Edit
}
